import React from 'react'
import {useAuth} from './auth'
import { Navigate, useLocation } from 'react-router-dom';

export const RequireAuth =({children})=> {
    const auth = useAuth()
    const auth_2fa=localStorage.getItem('_id')
    const location =useLocation()
    if(!auth.user){
        return <Navigate to="/login" state={{path:location.pathname}}/> 
    }
    // if(auth.user && auth_2fa=='253876F1A'){
    //     return <Navigate to="/2fa" state={{path:location.pathname}}/> 
    // }
    return children
}

